const icon = require('vue-svgicon');
icon.register({
    'pause': {
        width: 1024,
        height: 1024,
        viewBox: '0 0 1024 1024',
        data: `<path pid="0" d="M0 0h426.667v1024H0zm597.333 0H1024v1024H597.333z"/>`,
    },
});
